<template>
    <div class="home">
        <div style="margin-bottom: 10px">
            <Carousel loop autoplay :autoplay-speed="3000">
                <CarouselItem v-for="item in carousels">
                    <a v-if="item.link" :href="item.link" target="_blank">
                        <div class="carousel-image" :style="bannerImg(item)"></div>
                    </a>
                    <div v-else class="carousel-image" :style="bannerImg(item)"></div>
                </CarouselItem>
            </Carousel>
        </div>
        <Row v-if="page.id" class="wrap" :gutter="16">
            <template v-for="(blk,index) in page.layout">
                <Col  v-bind="blk" >
                    <template v-if="eleMap['_'+(index+1)]">
                        <template v-if="eleMap['_'+(index+1)].length===1">
                            <template v-for="ele in eleMap['_'+(index+1)]" >
                                <v-element :setting="ele">
                                </v-element>
                            </template>
                        </template>
                        <Row v-else :gutter="16">
                            <template v-for="ele in eleMap['_'+(index+1)]">
                                <Col  v-bind="ele.layout">
                                    <v-element :setting="ele" >
                                    </v-element>
                                </Col>
                            </template>
                        </Row>
                    </template>
                </Col>
            </template>
        </Row>
        <v-float-card v-if="page.floatCard==='1'&&page.floatImageId" :width="200" :height="160">
            <a :href="page.floatLink" target="_blank" class="news-img"><img :src="'/file/image/'+page.floatImageId"></a>
        </v-float-card>
    </div>
</template>
<style lang="less" scoped>
    .home{
        margin-bottom:20px ;
    }
    .wrap{
    }
    .carousel-image{
        height: 250px;
        background-size: 1000px 250px;
        background-repeat: no-repeat;
        background-position: center;
        position: relative;
    }
    .news-img{
        text-align: center;
        background: transparent;
        & img{
            max-width: 200px;
            max-height: 160px;
        }
    }
</style>
<script>
    import VFloatCard from "@/components/FloatCard";
    import VElement from "./Element";
    import {mapGetters,mapActions} from 'vuex'

    export default {
        name: 'home',
        data:()=>{
            return {
            }
        },
        computed:{
            eleMap(){
                let map = {};
                this.elements.forEach((o,i)=>{
                    let key = '_'+o.index;
                    let ls = map[key]||[];
                    ls.push(o);
                    map[key] = ls;
                });
                console.log(map);
                console.log(this.page);
                return map;

            },
            ...mapGetters('home',['page','elements','carousels'])
        },
        created(){
            this.fetch_home();
        },
        methods:{
            bannerImg(item){
                return {
                    'background-image':`url(${item.file})`
                }
            },
            ...mapActions('home',['fetch_home'])
        },
        components: {
            VElement,
            VFloatCard
        }
    }
</script>
